export const GET_ITEM_SERIES = 'GET_ITEM_SERIES';
export const GET_ITEM_SERIES_SUCCESS = 'GET_ITEM_SERIES_SUCCESS';
export const GET_ITEM_SERIES_FAILED = 'GET_ITEM_SERIES_FAILED';

export const ADD_ITEM_SERIES = 'ADD_ITEM_SERIES';
export const ADD_ITEM_SERIES_SUCCESS = 'ADD_ITEM_SERIES_SUCCESS';
export const ADD_ITEM_SERIES_FAILED = 'ADD_ITEM_SERIES_FAILED';

export const EDIT_ITEM_SERIES = 'EDIT_ITEM_SERIES';
export const EDIT_ITEM_SERIES_SUCCESS = 'EDIT_ITEM_SERIES_SUCCESS';
export const EDIT_ITEM_SERIES_FAILED = 'EDIT_ITEM_SERIES_FAILED';

export const DELETE_ITEM_SERIES = 'DELETE_ITEM_SERIES';
export const DELETE_ITEM_SERIES_SUCCESS = 'DELETE_ITEM_SERIES_SUCCESS';
export const DELETE_ITEM_SERIES_FAILED = 'DELETE_ITEM_SERIES_FAILED';

export const UPDATE_LAST_ITEM_NUMBER = 'UPDATE_LAST_ITEM_NUMBER';
export const UPDATE_LAST_ITEM_NUMBER_SUCCESS = 'UPDATE_LAST_ITEM_NUMBER_SUCCESS';
export const UPDATE_LAST_ITEM_NUMBER_FAILED = 'UPDATE_LAST_ITEM_NUMBER_FAILED';

export const SET_DEFAULT_ITEM_SERIES = 'SET_DEFAULT_ITEM_SERIES';
export const SET_DEFAULT_ITEM_SERIES_SUCCESS = 'SET_DEFAULT_ITEM_SERIES_SUCCESS';
export const SET_DEFAULT_ITEM_SERIES_FAILED = 'SET_DEFAULT_ITEM_SERIES_FAILED';